import QRCode from 'qrcode'
import { formatPoints } from './rewards'
import { redemptionUsable, stateLabel, itemDetails, formatDate } from './redemptions'

function imageFor(src) {
  return new Promise((resolve, reject) => { const image = new Image(); image.onload = () => resolve(image); image.onerror = () => reject(new Error('No se pudo preparar la imagen.')); image.src = src })
}
function linesFor(context, text, width) {
  const lines = []
  String(text || '').split('\n').forEach(paragraph => {
    let line = ''
    for (const word of paragraph.split(/\s+/)) {
      if (context.measureText(word).width > width) {
        if (line) { lines.push(line); line = '' }
        let part = ''
        for (const letter of word) { if (context.measureText(part + letter).width > width) { lines.push(part); part = '' } part += letter }
        line = part
      } else if (line && context.measureText(line + ' ' + word).width > width) { lines.push(line); line = word }
      else line += (line ? ' ' : '') + word
    }
    if (line) lines.push(line)
  })
  return lines
}

/** Generate a complete PNG at a fixed resolution, independent of viewport or scroll. */
export async function redemptionCardImage(row, now = Date.now()) {
  await document.fonts?.ready
  const usable = redemptionUsable(row, now)
  const width = 1080; const margin = 72; const contentWidth = width - margin * 2
  const canvas = document.createElement('canvas'); canvas.width = width
  const ctx = canvas.getContext('2d')
  const items = (row.items || []).map(item => {
    ctx.font = '700 38px Arial'
    const title = linesFor(ctx, `${formatPoints(item.quantity || 1)} × ${item.product_name || item.display_name || 'Producto'}`, contentWidth - 180)
    ctx.font = '28px Arial'
    const details = linesFor(ctx, itemDetails(item), contentWidth)
    return { item, title, details, height: Math.max(title.length, 1) * 48 + details.length * 38 + 48 }
  })
  canvas.height = 440 + (usable ? 788 : 170) + items.reduce((sum, item) => sum + item.height, 0) + 290
  if (canvas.height > 14000) throw new Error('Este canje tiene demasiados productos para una sola imagen. Abre su detalle para revisarlo.')
  ctx.fillStyle = '#fff9ef'; ctx.fillRect(0, 0, width, canvas.height)
  ctx.fillStyle = '#26331f'; ctx.fillRect(0, 0, width, 14)
  ctx.textAlign = 'center'; ctx.fillStyle = '#26331f'; ctx.font = '700 66px Georgia'; ctx.fillText('Afrogato', width / 2, 110)
  ctx.font = '700 28px Arial'; ctx.fillStyle = '#8a5a0c'; ctx.fillText('MI CANJE', width / 2, 162)
  ctx.font = '700 44px Arial'; ctx.fillStyle = '#26331f'; ctx.fillText(stateLabel(row, now), width / 2, 237)
  ctx.font = '28px Arial'; ctx.fillText(usable ? 'Muestra este QR en caja' : 'Comprobante · Este canje ya no tiene un QR activo', width / 2, 290)
  let y = 330
  if (usable) {
    const qr = await imageFor(await QRCode.toDataURL(row.qr_token, { width: 736, margin: 4, errorCorrectionLevel: 'M', color: { dark: '#172316', light: '#ffffff' } }))
    ctx.imageSmoothingEnabled = false; ctx.drawImage(qr, (width - 736) / 2, y, 736, 736); y += 788
  } else y += 170
  ctx.textAlign = 'left'; ctx.font = '700 30px Arial'; ctx.fillText('LO QUE CANJEASTE', margin, y + 40); y += 90
  for (const { item, title, details, height } of items) {
    ctx.fillStyle = '#26331f'; ctx.font = '700 38px Arial'
    title.forEach((line, i) => ctx.fillText(line, margin, y + 36 + i * 48))
    ctx.textAlign = 'right'; ctx.font = '700 32px Arial'
    ctx.fillText(`${formatPoints(Number(item.quantity || 1) * Number(item.unit_points || 0))} pts`, width - margin, y + 36)
    ctx.textAlign = 'left'; ctx.font = '28px Arial'; ctx.fillStyle = '#526046'
    details.forEach((line, i) => ctx.fillText(line, margin, y + title.length * 48 + 38 + i * 38))
    ctx.strokeStyle = '#d7d6c8'; ctx.beginPath(); ctx.moveTo(margin, y + height - 12); ctx.lineTo(width - margin, y + height - 12); ctx.stroke()
    y += height
  }
  ctx.font = '700 38px Arial'; ctx.fillStyle = '#26331f'; ctx.fillText('Puntos utilizados', margin, y + 50)
  ctx.textAlign = 'right'; ctx.fillText(`${formatPoints(row.points_spent)} pts`, width - margin, y + 50)
  ctx.textAlign = 'center'; ctx.font = '28px Arial'; ctx.fillStyle = '#526046'
  const date = row.redeemed_at_iso || row.redeemed_at || row.created_at_iso || row.created_at
  ctx.fillText(`${row.redeemed_at ? 'Entregado' : 'Fecha de canje'}: ${formatDate(date)}`, width / 2, y + 115)
  ctx.font = '24px Arial'; ctx.fillText(`Folio ${String(row.redemption_uuid || '').slice(-8).toUpperCase()}`, width / 2, y + 162)
  ctx.fillText(usable ? 'QR de un solo uso · Conserva tu comprobante' : 'afrogato.app · Conserva tu comprobante', width / 2, y + 208)
  return new Promise((resolve, reject) => canvas.toBlob(blob => blob ? resolve(blob) : reject(new Error('No se pudo crear la imagen.')), 'image/png'))
}
